<template>
  <Modal
    :styleModal="{ width: '520px', maxWidth: '100%' }"
    :closeHandler="close"
    :isOpen="isOpen"
  >
    <template v-slot:title>
      <div class="title_modal">{{ $t('modals.limit.title') }}</div>
    </template>
    <template v-slot:body>
      <div class="limit_body">
        <div class="limit_description">
          {{ description }}
        </div>

        <!-- Только для сниженного лимита: бот обновляет признаки доверенного аккаунта при любом сообщении -->
        <i18n-t
          v-if="restricted"
          keypath="modals.limit.botHint"
          tag="div"
          class="limit_description"
        >
          <template #bot>
            <a :href="TELEGRAM_URL" target="_blank" rel="noopener">{{ $t('modals.limit.botHintLink') }}</a>
          </template>
        </i18n-t>

        <div class="limit_rows">
          <LimitRow
            :label="$t('modals.limit.today')"
            :window="daily"
          />
          <LimitRow
            :label="$t('modals.limit.thisMonth')"
            :window="monthly"
          />
        </div>

        <div class="limit_note">
          {{ $t('modals.limit.note') }}
        </div>

        <div class="buttons">
          <Button color="blue" @click="close">
            {{ $t('modals.limit.ok') }}
          </Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { makeEvent } from '@/helpers/base/amplitude'
import { TELEGRAM_URL } from '@/helpers/variables'
import Modal from '@/components/modals/Modal.vue'
import Button from '@/components/buttons/Button.vue'
import LimitRow from '@/components/modals/LimitRow.vue'

export default {
  name: 'LimitExceededModal',
  components: {
    Modal,
    Button,
    LimitRow,
  },
  data() {
    return { TELEGRAM_URL }
  },
  computed: {
    ...mapGetters('limits', ['isOpen', 'restricted', 'daily', 'monthly']),
    // Сниженный лимит (новый недоверенный аккаунт): объясняем причину и как его снять.
    // Про Telegram Premium намеренно не пишем, только про Google Workspace
    description() {
      if (!this.restricted) return this.$t('modals.limit.description')
      return this.$t('modals.limit.descriptionRestricted', {
        daily: this.daily?.limit,
        monthly: this.monthly?.limit,
      })
    },
  },
  watch: {
    isOpen(value) {
      if (value) makeEvent('limit exceeded popup', { limit: 'domains' })
    },
  },
  methods: {
    ...mapMutations('limits', ['close']),
  },
}
</script>

<style scoped>
.title_modal {
  text-align: center;
  /* не наезжаем на крестик закрытия (он абсолютно спозиционирован справа) */
  padding: 0 28px;
}
@media (max-width: 576px) {
  .title_modal {
    font-size: 22px;
    line-height: 28px;
  }
}
.limit_body {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.limit_description {
  font-size: 15px;
  line-height: 21px;
  text-align: center;
  color: var(--text-secondary);
}
.limit_description a {
  color: var(--main-color);
  text-decoration: underline;
}
.limit_rows {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px 20px;
  background: var(--bg-surface-2);
  border-radius: 7px;
}
.limit_note {
  font-size: 13px;
  line-height: 18px;
  color: var(--text-secondary2);
  text-align: center;
}
.buttons {
  display: grid;
  margin-top: 6px;
}
</style>
